export default "__VITE_ASSET__3b2566c3__"